import { render, staticRenderFns } from "./SMSStats.vue?vue&type=template&id=03946404&"
import script from "./SMSStats.vue?vue&type=script&lang=js&"
export * from "./SMSStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03946404')) {
      api.createRecord('03946404', component.options)
    } else {
      api.reload('03946404', component.options)
    }
    module.hot.accept("./SMSStats.vue?vue&type=template&id=03946404&", function () {
      api.rerender('03946404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/SMSStats.vue"
export default component.exports